<template>
  <div id="sections-defences-armor-class-details-fifth-edition">
    <armor-detail :armorClass="armorClass.armor">Armor (Torso)</armor-detail>
    <div class="content" v-show="toggleState" style="clear:left;">
      <armor-detail :armorClass="armorClass.head">Head</armor-detail>
      <armor-detail :armorClass="armorClass.arms">Arms</armor-detail>
      <armor-detail :armorClass="armorClass.legs">Legs</armor-detail>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorDetail from "./_ArmorDetail.vue";

export default {
  name: "sections-defenses-details-fifth-edition",
  components: {
    ArmorDetail
  },
  props: ["toggleState"],
  computed: mapState({
    armorClass: state => state.characters.current.defense.armorClass
  })
};
</script>
